import { FLOW_SLUGS, isCommonStep, JOURNEY_TYPE_URL_SLUG } from '../../constants';
import { URLS } from '../../../../models/url/constants';
import type { JourneyProductType, StepSlug } from '../../types';

export const getAdjacentSlug = (
  direction: 'next' | 'prev',
  activeSlug: StepSlug,
  journeyType: JourneyProductType,
): StepSlug | null => {
  const flow = FLOW_SLUGS[journeyType];
  const idx = flow.indexOf(activeSlug);

  if (direction === 'next') {
    return flow[idx + 1] ?? null;
  }

  return idx <= 0 ? null : flow[idx - 1]!;
};

export const buildNavigationUrl = (target: StepSlug, journeyType: JourneyProductType): string => {
  if (isCommonStep(target)) {
    return `${URLS.SALES.CHOOSE_YOUR_COVER}/${target}`;
  }

  return `${URLS.SALES.CHOOSE_YOUR_COVER}/${JOURNEY_TYPE_URL_SLUG[journeyType]}/${target}`;
};
